export const PRODUCTS = [
    {
        "id": 1,
        "name": "Sweet Cheeks Blush Palette",
        "price": "70.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwa0a9cf48/ProductImages/2016/Face/Sweet_Cheeks_Blush_Palette/sweetcheeksblushpalette_main.jpg?sw=390&sh=390&sm=fit",
        "category": "blush PALETTE"
    },
    {
        "id": 2,
        "name": "Cheek Contour Duo Palette",
        "price": "25.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwb9e0511a/ProductImages/2016/Face/Cheek_Contour_Duo_Palette/800897012007_cheekcontourduopalette_doubledate_main.jpg?sw=390&sh=390&sm=fit",
        "category": "CONTOUR PALETTE"
    },
    {
        "id": 3,
        "name": "High Definition Blush Pro Refills",
        "price": "20.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw587b93a7/ProductImages/Face/High_Definition_Pro_Blush_Refills/highdefinitionproblushrefills_main.jpg?sw=390&sh=390&sm=fit",
        "category": "blush"
    },
    {
        "id": 4,
        "name": "Rouge Cream Blush",
        "price": "20.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dw91979480/ProductImages/Face/Rouge_Cream_Blush/rougecreamblush_main.jpg?sw=390&sh=390&sm=fit",
        "category": "CREAM blush"
    },
    {
        "id": 5,
        "name": "Stick Blush",
        "price": "15.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwb08ab0fe/ProductImages/Face/Stick_Blush/stickblush_main.jpg?sw=390&sh=390&sm=fit",
        "category": "STICK blush"
    },
    {
        "id": 6,
        "name": "Whipped Lip & Cheek Soufflé",
        "price": "25.0",
        "image": "https://www.nyxcosmetics.com/dw/image/v2/AANG_PRD/on/demandware.static/-/Sites-cpd-nyxusa-master-catalog/default/dwcffa1f2c/ProductImages/Lips/Whipped_Lip_And_Cheek_Souffle/whippedlipandcheeksouffle_main.jpg?sw=390&sh=390&sm=fit",
        "category": "blush"
    },
    {
        "id": 7,
        "name": "Clinique Pop™ Oil Lip & Cheek Glow",
        "price": "35.0",
        "image": "https://www.clinique.com/media/export/cms/products/181x209/clq_ZKJM01_181x209.png",
        "category": "lip oil"
    },
    {
        "id": 8,
        "name": "O-Glow",
        "price": "45.0",
        "image": "https://www.smashbox.com/media/images/products/388x396/sbx_sku_35746_388x396_0.jpg",
        "category": "cream blush"
    },
    {
        "id": 9,
        "name": "L.A. Lights Palette",
        "price": "50.0",
        "image": "https://www.smashbox.com/media/images/products/388x396/sbx_sku_69716_388x396_0.jpg",
        "category": "blush Palette"
    },
    {
        "id": 10,
        "name": "L.A. Lights Cheek & Lip Color",
        "price": "35.0",
        "image": "https://www.smashbox.com/media/images/products/388x396/sbx_sku_61630_388x396_0.jpg",
        "category": "lip stick"
    }
]
